<template>
	<div class="h-full bg-documentGray">
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
						:hideCategory="true"
    ></TopAppBar>
	<div class="d-flex h-full flex-column">
	<TopAppBarDrawer></TopAppBarDrawer>
		<main class="main-wrapper flex-grow-1 bg-documentGray">
			<div class="d-flex align-items-center bg-white">
				<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
					{{$t('3332')}}
				</div>
				<div class="mgr-24 right-button">
					<button class="mdc-icon-button" @click="searchOpen" @keypress="searchOpen" tabindex="0">
						<i class="material-icons">search</i>
					</button>
					</div>
									<div class="searchbar-with-category bg-white position-absolute w-full" :style="hiding">
								<div class="d-flex align-items-center pdt-8 pdb-8">
												<div class="mgl-12" @click="searchClose();" @keypress="searchClose();" tabindex="0">
													<i class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle"
																				id="search-category-close">close</i>
												</div>
												<div class="flex-grow-1 pdl-12 pdt-4">
																<input type="text" :placeholder="$t('3351')"
																				class="search_form w-full t-color-headlineBlack border-none t-headline8 cursor-blue"
																				autofocus v-model="contents" @keyup="getStoreSerach" />
												</div>
												<div class="mgr-22" @click="search" @keypress="search" tabindex="0">
													<i class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle"
																				id="search-category-close">search</i>
												</div>
								</div>

				</div>
			</div>
			<div class="divider"></div>
			<!-- subtabs -->
		   
			<div class="container container--narrow pdt-24">
				<div class="pdb-8 pdr-8 pdt-8">
					<div class="mdc-chip-set banner--chip chip--outlined top-chip pdl-0" role="grid">
						<div :class="['mdc-chip', { 'checked' : isAll}]" role="row" @click="getBoard('ALL','')" @keypress="getBoard('ALL','')" tabindex="0">
							<!-- <div class="mdc-chip__ripple"></div> -->
							<i class="material-icons mdc-chip__icon mdc-chip__icon--leading mgr-2 t-color-red" v-if="isAll">check</i>
							<span role="gridcell">
								<span class="mdc-chip__text t-body4 ">{{$t('3117')}}</span>
							</span>
						</div>
						<div tabindex="0" v-bind:class="['mdc-chip', { 'checked' :ischecked(board.value)}]" v-for="(board) in categoryList" :key="board.value + '-name'" role="row" @click="getBoard(board.value)" @keypress="getBoard(board.value)">
							<!-- <div class="mdc-chip__ripple"></div> -->
							<i class="material-icons mdc-chip__icon mdc-chip__icon--leading mgr-2 t-color-red" v-if="ischecked(board.value)">check</i>
							<span role="gridcell">
								<span class="mdc-chip__text  t-body4 font-r">{{board?board.text:''}}</span>
							</span>
						</div>
					</div>
				</div>
				<div v-if="suggestionBox==true">
				<div class="t-body3 t-color-bodyGrayA font-r" v-if="storeSearch && storeSearch.length>0">{{$t('3127')}}</div>
					<div class="community-search-list">
						<div v-for="(searchData,k) in storeSearch" :key="k.id">
							<div class="pdt-13 pdb-12">
								<div class="d-flex align-items-center justify-content-between search-list">
										<div class="d-flex align-items-center">
											<i class="material-icons t-color-iconInactive pdr-8 t-line-h-29">history</i>
											<div class="t-body3 font-r t-color-bodyGrayA" @click="setValueInSearch(searchData)" @keypress="setValueInSearch(searchData)" tabindex="0">{{searchData}}</div>
										</div>
										<div><i class="material-icons t-color-iconInactive close" @click="removeRecentSeachValue(k)" @keypress="removeRecentSeachValue(k)" tabindex="0">close</i></div>
								</div>
							</div>
							<div class="divider"></div>
						</div>
					</div>
				</div>
				<NoData class="pda-16" :contents="contents" :searchNoData="searchNoData" :filterCategory="selectBoardCategory" :selectedMenuType="selectedMenuType" v-if="isNoData && suggestionBox==false && searchNoData == false" ></NoData>
					<div v-else-if="searchNoData && isNoData && suggestionBox==false">
						<!-- <div class="t-center t-headline3 font-b t-line-h-28">
										"점검"
						</div> -->
						<div class="mgt-24">
								<div class="t-headline8 font-r t-center">
												{{$t('3339')}}
								</div>
								<div class="t-body1 font-r t-center mgt-4 t-color-bodyGrayA">
												{{$t('3340')}}
								</div>
						</div>
					</div>
				<div class="pdt-32 pdb-26" v-if="suggestionBox==false">
					<div class="mdc-card position-relative mgb-24"  v-for="(checklist, index2) in listData" :key="index2" @click.prevent="moveToDetail(checklist)" @keypress.prevent="moveToDetail(checklist)" tabindex="0">
						<div class="pdt-12 pdl-12 pdr-12 pdb-4 d-flex">
							<div class="mdc-chip-set mdc-chip-set--choice chip--tag-type p-0" @click.stop="" @keypress.stop="" tabindex="0">
								<div class="demo-chip mdc-chip bg-lecturePurpleBG16" tabindex="0">
									<!-- <div class="mdc-chip__ripple"></div>        -->
								  <div class="mdc-chip__text t-helper font-r t-color-lecturePurple">{{checklist.distribution.checklistPaper.hcategory.text}}</div>
								</div>
							</div>
							<div class="mdc-chip-set mdc-chip-set--choice chip--tag-type p-0"  @click.stop="" @keypress.stop="" tabindex="0">
								<div class="demo-chip mdc-chip bg-lectureYellowBG16" tabindex="0">
									<!-- <div class="mdc-chip__ripple"></div>        -->
								  <div class="mdc-chip__text t-helper font-r t-color-lectureYellow">{{checklist.distribution.checklistPaper.hcategory.child.text}}</div>
								</div>
							</div>        
						</div>
						<div class="pdl-24 pdr-24">
							<div class="t-body1 t-line-h-24 l-spacing48 font-r">{{checklist.distribution.name}}</div>
							<div class="t-body3 font-r t-color-bodyGrayA t-line-h-19 mgt-12">{{$moment(checklist.distribution.periodPolicy.post.start).format('L')}} ~ {{$moment(checklist.distribution.periodPolicy.post.end).format('L')}}</div>
						</div>
						<div class="pda-16 d-flex justify-content-between">
							<button class="mdc-button  mdc-button--leading t-color-bodyGrayA" @click.stop="" @keypress.stop="" tabindex="0">
								<span class="mdc-button__ripple"></span>
								<i class="material-icons mdc-button__icon" aria-hidden="true"
								  >playlist_add_check</i
								>
								<span class="mdc-button__label t-body4 l-spacing39 font-r">{{$t('3334',{str:checklist.submissionsCount})}}</span>
							</button>
							<button tabindex="0" class="mdc-button  mdc-button--leading t-color-red"  @click.stop="" @keypress.stop="" v-if="checklist.activeRespondentPaper && (checklist.activeRespondentPaper.status === 'SOLVING' && checklist.distribution.status.value === 'DEPLOYING')">
								<span class="mdc-button__ripple"></span>
								<i class="material-icons mdc-button__icon" aria-hidden="true"
								  >create</i
								>
								<span class="mdc-button__label t-body4 l-spacing39 font-r">{{$t('3335')}}</span>
							</button>
						</div>
					</div>
				</div>

			</div>
		<infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
			<div slot="no-more" class="mgt-16"></div>
			<div slot="no-results" class="mgt-16"></div>
		</infinite-loading>  
		</main> 
</div>
	</div>

</template>
<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import checklistApi from '@/api/checklistApi.js'
import NoData from '../common/NoDataCheckList.vue'
import InfiniteLoading from 'vue-infinite-loading'
import TopAppBar from "@/components/TopAppBar.vue";
export default {
	components: {
		InfiniteLoading,
		TopAppBarDrawer,
		NoData,
		TopAppBar
	},
	
	data() {
		return {
			status: '',
			isAll:true,
			isAllHide: false,
			isNoData: false,
			isDrawerOpen: false,
			fixListDataList: false,
			permissionAccess: false,
			campaignData: null,
			mamberData: null,
			userAuthData: null,
			selectedChild: null,
			listData: [],
			listData1:[],
			fixListData: [],
			selectedBoard:[],
			selectBoardCategory: null,
			filterCategory: null,
			categoryList:'',
			boardId: null,
			boardName:null,
			headerBoardName: null,
			categoryName:null,
			contents:'',
			menuBar: null,
			menuTypeTitle:this.$t('3119'),
			selectedMenuType:'ALL',
			showing:{'display':'block'},
			hiding:{'display':'none'},
			suggestionBox: false,
			storeSearch:[],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
			firstCharOfNames : localStorage.getItem('firstChar'),
			bgColorOfName : localStorage.getItem('bgColors'),
			searchNoData:false,
			searchClick: false
		}
	},

	mixins: [topAppBarMixin],
	
	computed: {
		uniqueCategory() {
			let temp=[]
			this.listData1.forEach(item =>{
				item.boardDto.boardCategory.childCategory.forEach(arra=>{
					temp.push(arra)
				})
			})
			var flags = [], output = [], l = temp.length, i;
			for( i=0; i<l; i++) {
				if( flags[temp[i].id]) continue;
				flags[temp[i].id] = true;
				output.push({
					id:temp[i].id,
					name:temp[i].name
				});
			}
			return output;
		}
	},

	watch:{
		$route (to, from){
			// this.boardId =  this.$route.params.boardId
			// this.boardName =  this.$route.query.boardName.replace('-','&')
			// this.categoryName =  this.$route.query.categoryName
			// this.selectBoardCategory=null
			// this.isAll=true
			// this.menuTypeTitle=this.$t('3119')
			// this.selectedMenuType='ALL'
			this.closeDrawer()
			this.initData()
			this.getCategoryList()
		}
	},
	mounted() {
			// this.boardId =  this.$route.params.boardId
			// this.boardName =  this.$route.query.boardName.replace('-','&')
			// this.categoryName =  this.$route.query.categoryName
			// const menuEls = Array.from(document.querySelectorAll('.mdc-menu'));
			// menuEls.forEach((menuEl) => {
			//     this.menuBar = new MDCMenu(menuEl);
			//     const dropdownToggle = menuEl.parentElement.querySelector('.js--dropdown-toggle');
			//     dropdownToggle.addEventListener('click', () => {
			//         this.menuBar.open = !this.menuBar.open;
			//     });
			// });
			this.getCategoryList()
	},

	methods: {
		initData() {
			this.listData= []
			this.currentPage = 1
			this.totalPages = 1
			this.infiniteId += 1
		},
		listFilter(str){
			let length = 90;
			let ending = ' ...';
			let str1='';
			if (str) {
				let str2 =str.replace(/<a [^>]+>[^<]*<\/a>/, '')
				let strRemoveBrTag = str2.replace(/<\/?[^>]+>/ig, " ");
				let strRemoveImgTags = strRemoveBrTag.replace(/<img[^>]*>/gi, "");
				let strRemoveRNTags = strRemoveImgTags.replace(/(\r\n|\n|\r)/gm, '');
				if(strRemoveRNTags.length>length){
					str1 = strRemoveRNTags.substring(0, length - ending.length) + ending;
					return str1;
				} else {
					return str.replace(/(\r\n|\n|\r)/gm, '<br/>');
				}
			} else {
				return str.replace(/(\r\n|\n|\r)/gm, '<br/>');
			}
		},
		

		getCategoryList() {
			//checklistApi.fetchCategoryList(this.$route.params).then(response => {
			checklistApi.fetchCategoryList().then(response => {
				this.categoryList = response.data.data
				}).catch(err => {
					console.log('err=>',err);
			});
		},

	  
		

		// 목록 데이터 로딩(get list data)
		fetchData($state) {
			let responseData = null
			let params = this.setParams()
		   
			if (this.totalPages >= this.currentPage) {
				checklistApi.fetchList(params).then((response) => {
					responseData = response.data.data
					this.listData = this.listData.concat(responseData.content)
					this.listData1 = this.listData
					this.currentPage++
					this.totalPages = responseData.totalPages

					if (responseData.content.length) {
						$state.loaded()
					}else {
						$state.complete()
					}
     if(this.contents && this.listData.length>0 && this.searchClick  == true){
								this.searchNoData = false;
								this.searchClick= false
					}
					else if(this.contents && this.listData.length<=0 && this.searchClick  == true){
						this.searchNoData = true;
						this.searchClick= false
					}
					else{
						this.searchNoData = false;
						this.searchClick =false
					}
					if (this.listData.length>0) {
						this.isNoData = false
						this.filterCategory =''
					} else {
						this.isNoData = true
						this.filterCategory =''
					}
				}).catch((err) => {
					$state.error()
				})

			}else {
				$state.complete()
			}
		},

		// 파라미터 설정(set parameter)
		setParams() {
			if( this.isAll==true) {
				const params = {
					name:this.contents,
					// subject:this.contents,
					// contents: this.contents,
					// statuses:'',
					// type:this.selectedMenuType,
					categoryId:'',
					page:this.currentPage,
					size:10,
					sort: "id,desc",
				}
			return params

			} else {
				const params = {
					name:this.contents,
					// subject:this.contents,
					// contents: this.contents,
					// statuses:'',
					// type:this.selectedMenuType,
					categoryId:this.selectBoardCategory,
					page:this.currentPage,
					size:10,
					sort: "id,desc",
				}
				return params
			}
			
		},

		// Board Category
		getBoard(selectedBoardId){
			this.selectBoardCategory = selectedBoardId
			if(this.selectBoardCategory=='ALL') {
				this.filterCategory = ''
				this.isAll=true
			} else {
				this.isAll=false;
				this.filterCategory = this.selectBoardCategory
			}
			
			this.initData()
			//this.getStaticData()
		},

		ischecked(checkecdBoardId) {
				// if(this.selectBoardCategory)
				// this.isAll=false;

				return this.selectBoardCategory == checkecdBoardId
			// return this.selectedBoard.find(arr=>arr==checkecdBoardId)? true:false     
		},

		// check type of video and image
		getType(contentType) {
			if(contentType) {
				return contentType.split("/")[0];
			}
				
		},
		
		searchOpen() {;
			this.suggestionBox=true
			this.isAllHide=true
			this.showing={'display':'none'};
			this.hiding={'display':'block'};
			this.storeSearch = JSON.parse(localStorage.getItem('datas'));
		},

		searchClose() {
			this.suggestionBox=false;
			this.isAllHide=false;
			this.fixListDataList = false;
			this.searchClick  = false;
			this.contents = ''
			this.initData()
			//this.$router.go(this.$router.currentRoute)
			this.showing={'display':'block'};
			this.hiding={'display':'none'}; 
		},

		search() {
			//localStorage.removeItem('datas')
			this.suggestionBox=false
			this.fixListDataList = true
			this.isAllHide=true
			this.initData();
			this.searchClick  = true;
			//this.getStaticData();
			this.showing={'display':'none'};
			this.hiding={'display':'block'};
			let tempArray = [];
			if(this.contents) {
				// console.log('search data')
				if(localStorage.getItem('datas')) {
					tempArray = JSON.parse(localStorage.getItem('datas'));
				}
				tempArray.push(this.contents)
				localStorage.setItem('datas', JSON.stringify(tempArray))
				// console.log(tempArray, ' ___tempArray')
			}
			else{
				this.searchNoData = true;
			}
		},
		
		// Recent Serach Suggestion
		getStoreSerach() {
			this.suggestionBox=true
			let charSearch = JSON.parse(localStorage.getItem('datas'));
			let searchResult = charSearch.includes(this.contents); 
			if(searchResult === true) {
				this.storeSearch = charSearch;
			} else {
						this.searchNoData = true;
			   this.storeSearch = ''
			}
		},

		setValueInSearch(searchData) {
			this.contents = searchData
			this.suggestionBox=false
			//this.fixListDataList = true
			this.initData();
			//this.getStaticData();
		},

		// Removed value from Recent Serach Suggestion
		removeRecentSeachValue(index) {
			this.storeSearch.splice(index, 1);
			localStorage.setItem('datas', JSON.stringify(this.storeSearch))
		},

		openDrawer() {
			this.isDrawerOpen = true;
		},
		// Close drawer
		closeDrawer() {
			this.isDrawerOpen = false;
		},

		// Go to detail page
		
		moveToDetail(checklist) {
			//console.log('postId',postId)
			this.$router.push({
				name: 'CheckListView',
				params: {postId:checklist.distribution.id},
				query: {status: checklist.status}
			})
		}
	}
}
</script>